export default __webpack_public_path__ + "static/media/boots_of_the_defiant.c83741b9.jpg";